type UpdateItemInListByIdProps<T> = {
  list: T[];
  updatedItem: Partial<T> & Record<string, unknown>;
  idKey: string;
};

export const updateItemInListById = <T extends Record<string, unknown>>({
  list,
  updatedItem,
  idKey
}: UpdateItemInListByIdProps<T>): T[] => {
  const idx = list.findIndex(
    (item) => item && item[idKey] === updatedItem[idKey]
  );
  if (idx === -1) return list;
  return [
    ...list.slice(0, idx),
    { ...list[idx], ...updatedItem },
    ...list.slice(idx + 1)
  ];
};
